import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadTrialInstitutionLaboratoryFinanceByTrialInstitutionLaboratoryId: ITrialInstitutionLaboratoryFinanceLoadByTrialInstitutionLaboratoryIdActionCreator = (trialInstitutionLaboratoryId) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYFINANCE_LOAD_BY_TRIAL_INSTITUTION_LABORATORY_ID,
            trialInstitutionLaboratoryId
        }
    },
    LoadTrialInstitutionLaboratoryFinanceById: ITrialInstitutionLaboratoryFinanceLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYFINANCE_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: ITrialInstitutionLaboratoryFinanceLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYFINANCE_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ITrialInstitutionLaboratoryFinanceLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYFINANCE_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveTrialInstitutionLaboratoryFinance: ITrialInstitutionLaboratoryFinanceSaveActionCreator = (formData) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SAVE,
            formData
        }
    },
    SaveSuccess: ITrialInstitutionLaboratoryFinanceSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ITrialInstitutionLaboratoryFinanceSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SAVE_FAILURE,
            responseStatus
        }
    },

    ValidateTrialInstitutionLaboratoryFinance: ITrialInstitutionLaboratoryFinanceValidateActionCreator = (formData) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYFINANCE_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ITrialInstitutionLaboratoryFinanceValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYFINANCE_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ITrialInstitutionLaboratoryFinanceValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYFINANCE_VALIDATE_FAILURE,
            responseStatus
        }
    },

    CreateTrialInstitutionLaboratoryFinance: ITrialInstitutionLaboratoryFinanceCreateActionCreator = (trialInstitutionLaboratoryId) => {

        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYFINANCE_CREATE,
            trialInstitutionLaboratoryId
        }
    },
    CreateSuccess: ITrialInstitutionLaboratoryFinanceCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYFINANCE_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ITrialInstitutionLaboratoryFinanceCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYFINANCE_CREATE_FAILURE,
            responseStatus
        }
    },

    SyncTrialInstitutionLaboratoryFinance: ITrialInstitutionLaboratoryFinanceSyncActionCreator = (trialInstitutionLaboratoryId) => {

        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SYNC,
            trialInstitutionLaboratoryId
        }
    },
    SyncSuccess: ITrialInstitutionLaboratoryFinanceSyncSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SYNC_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    SyncFailure: ITrialInstitutionLaboratoryFinanceSyncFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SYNC_FAILURE,
            responseStatus
        }
    },

    Clear: ITrialInstitutionLaboratoryFinanceClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYFINANCE_CLEAR,
            propertiesToClear
        }
    },

    Filter: ITrialInstitutionLaboratoryFinanceFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYFINANCE_FILTER,
            formFilter
        }
    };



export const
    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_LOAD_BY_TRIAL_INSTITUTION_LABORATORY_ID = "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_LOAD_BY_TRIAL_INSTITUTION_LABORATORY_ID",
    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_LOAD_BY_ID = "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_LOAD_BY_ID",
    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_LOAD_SUCCESS = "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_LOAD_SUCCESS",
    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_LOAD_FAILURE = "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_LOAD_FAILURE",

    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SAVE = "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SAVE",
    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SAVE_SUCCESS = "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SAVE_SUCCESS",
    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SAVE_FAILURE = "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SAVE_FAILURE",

    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_VALIDATE = "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_VALIDATE",
    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_VALIDATE_SUCCESS = "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_VALIDATE_SUCCESS",
    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_VALIDATE_FAILURE = "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_VALIDATE_FAILURE",

    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_CREATE = "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_CREATE",
    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_CREATE_SUCCESS = "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_CREATE_SUCCESS",
    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_CREATE_FAILURE = "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_CREATE_FAILURE",

    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SYNC = "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SYNC",
    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SYNC_SUCCESS = "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SYNC_SUCCESS",
    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SYNC_FAILURE = "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SYNC_FAILURE",

    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_CLEAR = "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_CLEAR",

    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_FILTER = "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_FILTER";

export interface ITrialInstitutionLaboratoryFinanceLoadByTrialInstitutionLaboratoryIdAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_LOAD_BY_TRIAL_INSTITUTION_LABORATORY_ID";
    trialInstitutionLaboratoryId: number;
}

export interface ITrialInstitutionLaboratoryFinanceLoadByTrialInstitutionLaboratoryIdActionCreator {
    (trialInstitutionLaboratoryId: number): ITrialInstitutionLaboratoryFinanceLoadByTrialInstitutionLaboratoryIdAction;
}

export interface ITrialInstitutionLaboratoryFinanceLoadSuccessAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_LOAD_SUCCESS";
    formData: Dtos.TrialInstitutionLaboratoryFinance | Dtos.TrialInstitutionLaboratoryFinance[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionLaboratoryFinanceLoadSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionLaboratoryFinance | Dtos.TrialInstitutionLaboratoryFinance[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialInstitutionLaboratoryFinanceLoadSuccessAction;
}

export interface ITrialInstitutionLaboratoryFinanceLoadFailureAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionLaboratoryFinanceLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryFinanceLoadFailureAction;
}

export interface ITrialInstitutionLaboratoryFinanceLoadByIdAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_LOAD_BY_ID";
    id: number;
}

export interface ITrialInstitutionLaboratoryFinanceLoadByIdActionCreator {
    (id: number): ITrialInstitutionLaboratoryFinanceLoadByIdAction;
}

export interface ITrialInstitutionLaboratoryFinanceSaveAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SAVE";
    formData: Dtos.TrialInstitutionLaboratoryFinance;

}

export interface ITrialInstitutionLaboratoryFinanceSaveActionCreator {
    (
        formData: Dtos.TrialInstitutionLaboratoryFinance
    ): ITrialInstitutionLaboratoryFinanceSaveAction;
}

export interface ITrialInstitutionLaboratoryFinanceSaveSuccessAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SAVE_SUCCESS";
    formData: Dtos.TrialInstitutionLaboratoryFinance;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionLaboratoryFinanceSaveSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionLaboratoryFinance,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialInstitutionLaboratoryFinanceSaveSuccessAction;
}

export interface ITrialInstitutionLaboratoryFinanceSaveFailureAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionLaboratoryFinanceSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryFinanceSaveFailureAction;
}

export interface ITrialInstitutionLaboratoryFinanceValidateAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_VALIDATE";
    formData: Dtos.TrialInstitutionLaboratoryFinance;

}

export interface ITrialInstitutionLaboratoryFinanceValidateActionCreator {
    (
        formData: Dtos.TrialInstitutionLaboratoryFinance
    ): ITrialInstitutionLaboratoryFinanceValidateAction;
}

export interface ITrialInstitutionLaboratoryFinanceValidateSuccessAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_VALIDATE_SUCCESS";
    formData: Dtos.TrialInstitutionLaboratoryFinance;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionLaboratoryFinanceValidateSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionLaboratoryFinance,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialInstitutionLaboratoryFinanceValidateSuccessAction;
}

export interface ITrialInstitutionLaboratoryFinanceValidateFailureAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionLaboratoryFinanceValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryFinanceValidateFailureAction;
}

export interface ITrialInstitutionLaboratoryFinanceCreateAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_CREATE",
    trialInstitutionLaboratoryId: number
}

export interface ITrialInstitutionLaboratoryFinanceCreateActionCreator {
    (trialInstitutionLaboratoryId: number): ITrialInstitutionLaboratoryFinanceCreateAction
}

export interface ITrialInstitutionLaboratoryFinanceCreateSuccessAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_CREATE_SUCCESS";
    formData: Dtos.TrialInstitutionLaboratoryFinance;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface ITrialInstitutionLaboratoryFinanceCreateSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionLaboratoryFinance,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ITrialInstitutionLaboratoryFinanceCreateSuccessAction;
}

export interface ITrialInstitutionLaboratoryFinanceCreateFailureAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionLaboratoryFinanceCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryFinanceCreateFailureAction;
}

export interface ITrialInstitutionLaboratoryFinanceClearAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_CLEAR";
    propertiesToClear?: string[];
}

export interface ITrialInstitutionLaboratoryFinanceClearActionCreator {
    (propertiesToClear?: string[]): ITrialInstitutionLaboratoryFinanceClearAction;
}

export interface ITrialInstitutionLaboratoryFinanceFilterActionCreator {
    (formFilter: IFormFilter): ITrialInstitutionLaboratoryFinanceFilterAction;
}

export interface ITrialInstitutionLaboratoryFinanceFilterAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_FILTER";
    formFilter: IFormFilter;
}

export interface ITrialInstitutionLaboratoryFinanceSyncAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SYNC",
    trialInstitutionLaboratoryId: number
}

export interface ITrialInstitutionLaboratoryFinanceSyncActionCreator {
    (trialInstitutionLaboratoryId: number): ITrialInstitutionLaboratoryFinanceSyncAction
}

export interface ITrialInstitutionLaboratoryFinanceSyncSuccessAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SYNC_SUCCESS";
    formData: Dtos.TrialInstitutionLaboratoryFinance[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionLaboratoryFinanceSyncSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionLaboratoryFinance[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialInstitutionLaboratoryFinanceSyncSuccessAction;
}

export interface ITrialInstitutionLaboratoryFinanceSyncFailureAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SYNC_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionLaboratoryFinanceSyncFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryFinanceSyncFailureAction;
}

export type TrialInstitutionLaboratoryFinanceAction =
    ITrialInstitutionLaboratoryFinanceLoadByTrialInstitutionLaboratoryIdAction |
    ITrialInstitutionLaboratoryFinanceLoadByIdAction |
    ITrialInstitutionLaboratoryFinanceLoadFailureAction |
    ITrialInstitutionLaboratoryFinanceLoadSuccessAction |
    ITrialInstitutionLaboratoryFinanceSaveAction |
    ITrialInstitutionLaboratoryFinanceSaveSuccessAction |
    ITrialInstitutionLaboratoryFinanceSaveFailureAction |
    ITrialInstitutionLaboratoryFinanceValidateAction |
    ITrialInstitutionLaboratoryFinanceValidateSuccessAction |
    ITrialInstitutionLaboratoryFinanceValidateFailureAction |
    ITrialInstitutionLaboratoryFinanceCreateAction |
    ITrialInstitutionLaboratoryFinanceCreateSuccessAction |
    ITrialInstitutionLaboratoryFinanceCreateFailureAction |
    ITrialInstitutionLaboratoryFinanceSyncAction |
    ITrialInstitutionLaboratoryFinanceSyncSuccessAction |
    ITrialInstitutionLaboratoryFinanceSyncFailureAction |
    ITrialInstitutionLaboratoryFinanceClearAction | 
    ITrialInstitutionLaboratoryFinanceFilterAction;
